import ExclusiveLegacyPricingShared from "./ExclusiveLegacyPricingShared";

export default function LegacyPricingPage() {
  return <ExclusiveLegacyPricingShared variant="legacy" />;
}
